// DS: DEV8
import React from 'react';
import c from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import DeviationDumbView from '../DeviationViews/Dumbo';
import s from './GallectionCoverDumbo.scss';

export interface Props {
  width?: number;
  height?: number;
  className?: string;
  gallection: PapiGallection;
  placeholder?: React.ReactNode;
  placeholderClassName?: string;
}

const GallectionCoverDumbo: React.FC<Props> = ({
  width,
  height,
  className,
  gallection: { thumb },
  placeholder,
  placeholderClassName,
}) => {
  if (!thumb) {
    return (
      <div
        className={c(className, placeholderClassName || s['no-image'])}
        style={{ width, height }}
      >
        {placeholder}
      </div>
    );
  }
  return (
    <DeviationDumbView className={className} width={width} height={height} deviation={thumb} />
  );
};
GallectionCoverDumbo.displayName = 'GallectionCoverDumbo';

export default GallectionCoverDumbo;
